import React, { useState } from "react";
import { Select, Card, Row, Col, Typography, Image } from "antd";
import { galleryData } from "./galleryData";

const { Option } = Select;
const { Title } = Typography;

const Gallery = () => {
  const [selectedEvent, setSelectedEvent] = useState("2024 Annual Meeting");
  const currentImages = galleryData[selectedEvent] || [];
  return (
    <div className="p-4">
      <div className="flex justify-center py-4">
        <h2 className="font-bold tracking-wide text-2xl md:text-3xl md:mb-6">
        <Title level={3}>Event Gallery</Title>
          <div class="animation h-1 mt-1"></div>
        </h2>
      </div>
      <Select
        value={selectedEvent}
        style={{ width: 250, marginBottom: 24 }}
        onChange={(value) => setSelectedEvent(value)}
      >
        {Object.keys(galleryData).map((eventKey) => (
          <Option key={eventKey} value={eventKey}>
            {eventKey}
          </Option>
        ))}
      </Select>

      <Image.PreviewGroup>
        <Row gutter={[16, 16]}>
          {currentImages.map((image) => (
            <Col xs={24} sm={12} md={8} lg={6} key={image.id}>
              <Card
                hoverable
                cover={
                  <Image
                    src={image.image}
                    alt={image.title}
                    height={200}
                    style={{ objectFit: "cover", borderRadius: "8px 8px 0 0" }}
                    preview={{
                        title: image.title,
                        description: image.title,
                      }}
                  />
                }
              >
                <Card.Meta title={image.title} />
              </Card>
            </Col>
          ))}
        </Row>
      </Image.PreviewGroup>

    </div>
  );
};

export default Gallery;
